import { priceCountry } from '@/utils/priceCountry'

export default {
  computed: {
    priceCountry() {
      return priceCountry({
        accountCountry: this.$auth.loggedIn
          ? this.$auth.user?.country?.iso
          : null,
        chosenCountry: this.$store.state.chosen_country,
        locale: this.$i18n.locale,
      })
    },
  },
}
